// extracted by mini-css-extract-plugin
export default {"container":"qr-scanner-pairing-page_container__dBi-0","title":"qr-scanner-pairing-page_title__t82AL","description":"qr-scanner-pairing-page_description__s6gWS"};